import { Location } from '@/features/location'
import { dataLayerPush } from '@/utils/dataLayerPush'
import { hotelSelectionEvent } from '@/utils/trackingEvents'

import { LocationSlice, SliceState } from './types'

export const createLocationSlice: SliceState<LocationSlice> = (set) => ({
	location: undefined,
	setLocation: (location?: Location) =>
		set(
			(state) => {
				if (state.location?.hotelCode === location?.hotelCode) return state

				if (location) {
					dataLayerPush(hotelSelectionEvent(location, state.promotion.code))
				}

				if (state.promotion.promotions.length > 0) {
					const activePromotion = state.promotion.promotions.find(
						(p) => p.hotelCode === location?.hotelCode
					)

					return {
						...state,
						location,
						promotion: { ...state.promotion, activePromotion },
					}
				}

				return { ...state, location, promotion: { ...state.promotion } }
			},
			false,
			'setLocation'
		),
})
